import { createSlice, createEntityAdapter, PayloadAction, EntityState } from '@reduxjs/toolkit';
import ActionState, { ActionStatus } from 'store/ActionState';
import KubernetesClusterObject, { GetKubernetesClusterOptions } from 'gql/KubernetesCluster';

export type KubernetesClusterState = {
  kubernetesCluster?: KubernetesClusterObject | null;
  fetchClusterState: ActionState;
  kubernetesClusters: EntityState<KubernetesClusterObject> | null;
  fetchClustersState: ActionState;
};

export const clusterAdapter = createEntityAdapter<KubernetesClusterObject>();

export const initialState: KubernetesClusterState = {
  kubernetesCluster: null,
  fetchClusterState: { status: ActionStatus.IDLE },

  kubernetesClusters: null,
  fetchClustersState: { status: ActionStatus.IDLE },
};

const KubernetesClusterSlice = createSlice({
  name: 'cluster',
  initialState,
  reducers: {
    fetchCluster: (state, _: PayloadAction<GetKubernetesClusterOptions>): KubernetesClusterState => {
      return { ...state, fetchClusterState: { status: ActionStatus.PROCESSING } };
    },
    fetchClusterSucceeded: (
      state,
      action: PayloadAction<KubernetesClusterObject | undefined>
    ): KubernetesClusterState => {
      return {
        ...state,
        kubernetesCluster: action.payload,
        fetchClusterState: { status: ActionStatus.SUCCEEDED },
      };
    },
    fetchClusterFailed: (state, action: PayloadAction<Error>): KubernetesClusterState => {
      return {
        ...state,
        fetchClusterState: { status: ActionStatus.FAILED, error: action.payload },
      };
    },
    fetchClusters: (state, _: PayloadAction): KubernetesClusterState => {
      return { ...state, fetchClustersState: { status: ActionStatus.PROCESSING } };
    },
    fetchClustersSucceeded: (state, action: PayloadAction<KubernetesClusterObject[]>): KubernetesClusterState => {
      return {
        ...state,
        kubernetesClusters: clusterAdapter.setAll(
          state.kubernetesClusters ? { ...state.kubernetesClusters } : clusterAdapter.getInitialState(),
          action.payload
        ),
        fetchClustersState: { status: ActionStatus.SUCCEEDED },
      };
    },
    fetchClustersFailed: (state, action: PayloadAction<Error>): KubernetesClusterState => {
      return {
        ...state,
        fetchClustersState: { status: ActionStatus.FAILED, error: action.payload },
      };
    },
  },
});

export default KubernetesClusterSlice;
